<template>
  <div class="container">
    <div class="ban-box">
      <van-image
        src="https://files.alighting.com/Cover/special_20220524.png"
        class="bg"
        fit="contain"
      ></van-image>
      <div class="ban_ul">
        <div @click="toLink(1)">首页</div>
        <div>品牌连线</div>
        <div @click="toLink(2)">品牌新品推荐</div>
        <!-- <div @click="toLink(3)">品牌直播</div> -->
      </div>
    </div>
    <div class="list">
      <div class="itemBox" v-for="(item, index) in list" :key="index">
        <mini-program
          :path="
            '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
          "
        >
          <van-image :src="item.Cover" fit="cover" class="coverImg"></van-image>
        </mini-program>
        <div class="title">{{ item.Title }}</div>
        <div class="time">开播时间：{{ item.StartTime }}</div>
        <div>
          <div style="font-size: 13px" v-if="item.BrandList.length > 0">
            参与品牌：
          </div>
          <div class="imglist">
            <van-image
              v-for="(imgItem, imgIndex) in item.BrandList"
              :key="imgIndex"
              :src="imgItem.Img"
              fit="contain"
              class="imgBrand"
            ></van-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { exhActivityLiveList } from "@/api/online";
import { Image } from "vant";
import miniProgram from "@/components/miniProgram";
export default {
  name: "brandLive",
  components: {
    "van-image": Image,
    miniProgram,
  },
  data() {
    return {
      list: [],
    };
  },

  methods: {
    //底部tab跳转
    toLink(n) {
      if (n == 1) {
        this.$router.replace({ path: "/onlineExhibitionTopics" });
      } else if (n == 2) {
        this.$router.push({ path: "/newBrands", query: { type: 0 } });
      } else if (n == 3) {
        this.$router.push({ path: "/lbList", query: { sid: 13, lid: 75 } });
      }
    },

    //获取品牌连线
    getList() {
      exhActivityLiveList().then((res) => {
        this.list = res.Data.List;
      });
    },
  },

  mounted() {
    if (!this.Common._isMobile()) {
      window.location.href =
        "https://www.alighting.com/Views/2022onlineexhibition/list.html";
    } else {
      this.getList();
    }
  },
};
</script>
<style scoped src="../../../static/css/brandLive.css">
</style>